// Copyright 2016 The Oppia Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Controller for the navbar breadcrumb of the skill editor.
 */
require('domain/utilities/UrlInterpolationService.ts');
require('pages/skill-editor-page/services/skill-editor-state.service.ts');
var oppia = require('AppInit.ts').module;
oppia.directive('skillEditorNavbarBreadcrumb', [
    'UrlInterpolationService', function (UrlInterpolationService) {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: UrlInterpolationService.getDirectiveTemplateUrl('/pages/skill-editor-page/navbar/' +
                'skill-editor-navbar-breadcrumb.directive.html'),
            controller: [
                '$scope', 'SkillEditorStateService',
                function ($scope, SkillEditorStateService) {
                    var skill = SkillEditorStateService.getSkill();
                    $scope.getTruncatedDescription = function () {
                        var truncatedDescription = skill.getDescription().substr(0, 40);
                        if (skill.getDescription().length > 40) {
                            truncatedDescription += '...';
                        }
                        return truncatedDescription;
                    };
                }
            ]
        };
    }
]);
